import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { T } from "@transifex/react";
import { useRouter } from "expo-router";
import { Pressable } from "react-native";

function TermsTextLink() {
  const router = useRouter();
  return (
    <VStack className="flex items-center justify-center">
      <Text className="font-[400] leading-[20px] text-[14px] text-center text-typography-900">
        <T _str="By continuing you agree to our" />
        {"\n"}
        <Pressable className="inline active:opacity-70" onPress={() => router.push("/terms-of-use")}>
          <Text className="font-[700] leading-[20px] text-[14px] text-nowrap text-typography-900 underline">
            <T _str="Terms of Use" />
          </Text>
          <Text className="font-[400] leading-[20px] text-[14px] text-center text-typography-900">
            {" "}
            <T _str="and" />{" "}
          </Text>
          <Pressable className="inline active:opacity-70" onPress={() => router.push("/privacy-policy")}>
            <Text className="font-[700] leading-[20px] text-[14px] text-nowrap text-typography-900 underline">
              <T _str="Privacy Policy" />
            </Text>
          </Pressable>
        </Pressable>
      </Text>
    </VStack>
  );
}
export default TermsTextLink;
